import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestLinkCard',
  props: {
    linkId: null,
    href: null,
    imgSrc: null,
    title: null,
    lead: null,
    cta: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})